(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('configureMetric', configureMetric);

	configureMetric.$inject = ['$rootScope', '$scope', '$state', '$timeout',
		'$location', '$uibModal', 'configureMetricService', 'storeService'];

	function configureMetric($rootScope, $scope, $state, $timeout, $location, $uibModal, configureMetricService, storeService) {
		var adminConfig = storeService.getState().adminConfig;

		$scope.hideDelete = false;
		$scope.metricNdx = $location.search().ndx;
		var newMetric = false;
		if ($scope.metricNdx) {
			$scope.title = 'Configure Metric';
			$scope.hideDelete = true;
		} else {
			$scope.title = 'Add Metric';
			newMetric = true;
			$scope.hideDelete = true;
		}

		$scope.allChartTypes = [{
			name: 'Line Chart',
			value: 'MSLine',
			categorized: false
		},
		{
			name: 'Column Chart',
			value: 'MSColumn2D',
			categorized: false
		},
		{
			name: 'Spline Chart',
			value: 'MSSpline',
			categorized: false
		},
		{
			name: 'Stacked Bar Chart',
			value: 'StackedBar',
			categorized: true
		},
		{
			name: 'Bar Chart',
			value: 'SeparateBar',
			categorized: true
		}
		];
		$scope.periodAggregationTypes = ['Average', 'Last', 'Max', 'Min', 'Sum'];
		$scope.booleanValues = [{
			name: 'Yes',
			value: true
		},
		{
			name: 'No',
			value: false
		}
		];
		$scope.valueStreamAggregationTypes = ['Average', 'Sum'];
		$scope.crossSiteAggregationTypes = ['Average', 'Sum'];
		$scope.displayResolutionTypes = ['Daily', 'Weekly', 'Monthly'];
		$scope.resolutionTypes = [{
			name: 'Plant',
			value: 'Plant'
		},
		{
			name: 'Value Stream',
			value: 'ValueStream'
		}
		];
		$scope.goalTypes = [{
			name: 'Above Target',
			value: 'Above'
		},
		{
			name: 'Below Target',
			value: 'Below'
		}
		];
		$scope.targetPeriodTypes = [{
			name: 'Monthly',
			value: 'Monthly'
		}
		];
		$scope.displayTypes = [{
			name: 'Percentage',
			value: 'percentage'
		},
		{
			name: 'Currency',
			value: 'currency'
		},
		{
			name: 'Number',
			value: 'float'
		}
		];
		$scope.currencyInputOptions = [{
			name: 'Numerator',
			value: 'Numerator'
		},
		{
			name: 'Denominator',
			value: 'Denominator'
		},
		{
			name: 'Both',
			value: 'Both'
		},
		{
			name: 'Neither',
			value: 'Neither'
		}
		];
		$scope.valueTypes = [{
			name: 'Single value',
			value: 'value'
		},
		{
			name: 'Ratio',
			value: 'percent'
		}
		];
		$scope.dataEntryTypes = [{
			name: 'Manual',
			value: 'Manual'
		},
		{
			name: 'Automatic',
			value: 'Automatic'
		}
		];
		$scope.valueStreams = [];
		$scope.selected = {};
		$scope.selected.valueStreams = [];
		$scope.metric = {};
		$scope.pageLoaded = false;
		$scope.archiveValueStreams = false;
		// scope functions
		$scope.clearToast = clearToast;
		$scope.categoryTagTransform = categoryTagTransform;
		$scope.levelTagTransform = levelTagTransform;
		$scope.clearErrorMessage = clearErrorMessage;
		$scope.cancel = cancel;
		$scope.deleteMetric = deleteMetric;
		$scope.validForm = validForm;
		$scope.submit = submit;
		$scope.refreshListResults = refreshListResults;

		$timeout(function () {
			jQuery('#metricsAndGoalsConfigureMetrics').addClass('selected');
			init();
		}, 0);

		function init() {
			getData($scope.metricNdx);
		}

		function clearToast() {
			$scope.toastMessage = undefined;
		}

		function categoryTagTransform(newTag) {
			var newCategory = {
				'categoryType': newTag
			};
			return newCategory;
		}

		function levelTagTransform(newTag) {
			var newLevel = {
				'metricLevelType': newTag
			};
			return newLevel;
		}

		function refreshListResults($select, type) {
			var search = $select.search,
				list = angular.copy($select.items),
				FLAG = -1;
			//remove last user input
			list = list.filter(function (item) {
				return item.id !== FLAG;
			});

			if (!search) {
				//use the predefined list
				$select.items = list;
			} else {
				//manually add user input and set selection
				var userInputItem = {
					id: FLAG,
					extraLabel: ' (Click or press Enter to create)'
				};
				userInputItem[type] = search;
				$select.items = [userInputItem].concat(list);
				$select.selected = $select.items[0];
				$select.activeIndex = 0;
				$select.activate($select.items[0]);
			}
		}

		function getData(metricNdx) {
			if (metricNdx) {
				$scope.archiveValueStreams = true;
				configureMetricService.getMetric(metricNdx, adminConfig.factory.id)
					.then(initFormWithMetric);
			} else {
				initFormWithDefaults();
			}

			configureMetricService.getCategories(adminConfig.factory.id)
				.then(function initCategories(categories) {
					$scope.categories = categories;
				});
			configureMetricService.getTypes(adminConfig.factory.id)
				.then(function initMetricLevelTypes(types) {
					$scope.metricLevelTypes = types;
				});
			configureMetricService.getUsers(adminConfig.factory.id)
				.then(function initUsers(users) {
					$scope.users = users;
					checkForInactive();
				});
			configureMetricService.getValueStreams($scope.archiveValueStreams, adminConfig.factory.id)
				.then(function initValueStreams(valueStreams) {
					$scope.valueStreams = valueStreams;
					updateSelectedValueStreams();
				});
		}

		function findValueStreamByNdx(ndx) {
			if ($scope.valueStreams) {
				for (var i = 0; i < $scope.valueStreams.length; i++) {
					if ($scope.valueStreams[i].ndx === ndx) {
						return $scope.valueStreams[i];
					}
				}
			}
			return undefined;
		}

		function updateSelectedValueStreams() {
			if ($scope.valueStreams && $scope.valueStreams.length > 0 &&
					$scope.selectedValueStreamNdxs &&
					$scope.selectedValueStreamNdxs.length > 0) {
				if ($scope.selectedValueStreamNdxs !== '') {
					var ndxArray = $scope.selectedValueStreamNdxs.split(',');
					angular.forEach(ndxArray, function (ndx) {
						$scope.selected.valueStreams.push(findValueStreamByNdx(parseInt(ndx)));
					});
				}
			}
		}

		function checkForInactive() {
			if ($scope.users && $scope.users.length &&
					$scope.metric && $scope.metric.assignedUser) {
				var found = false;
				for (var i = 0; i < $scope.users.length; i++) {
					if ($scope.users[i].userNdx === $scope.metric.assignedUser) {
						found = true;
						break;
					}
				}

				if (!found) {
					$scope.users.push({
						responsibleName: $scope.metric.assignedUserDisplay + ' (inactive)',
						userNdx: $scope.metric.assignedUser
					});
				}
			}
		}

		function initFormWithMetric(response) {
			var metric = response.data;
			if (metric === '') {
				$rootScope.$emit('toast', {
					'message': 'No metric found. If you changed sites in a different tab, this metric may have been for a different site. Return to the View Metrics page to view metrics for the current site. (click to dismiss)',
					'success': false,
					'time': 15000
				});
			}
			$scope.dateModified = response.headers('Last-Modified');
			$scope.metric.active = Boolean(metric.activatedFlag);
			$scope.metric.assignedUser = metric.userNdx;
			$scope.metric.assignedUserDisplay = metric.ownerName;
			checkForInactive();
			$scope.metric.category = metric.categoryType;
			$scope.metric.chartType = metric.chartType;
			$scope.metric.controlTowerAggregationType = metric.dataAggregationForMonthlyRollup;
			$scope.metric.crossSiteAggregation = metric.crossSiteAggregation;
			$scope.metric.cumulative = Boolean(metric.cumulative);
			$scope.metric.dataEntryType = metric.metricType;
			if ($scope.metric.dataEntryType === 'ProcurementLog') {
				$scope.hideDelete = true;
				$scope.valueTypes = [{
					name: 'System calculated',
					value: 'procurementLog',
					hidden: true
				}];
			} else {
				$scope.hideDelete = false;
			}
			$scope.metric.description = metric.description;
			$scope.metric.displayResolutionType = metric.displayResolutionType;
			$scope.metric.displayType = metric.displayType;
			$scope.metric.goalType = metric.goalType;
			$scope.metric.targetPeriodType = metric.targetPeriodType;
			$scope.metric.originalTargetPeriodType = metric.targetPeriodType;
			$scope.metric.currencyInput = metric.currencyInput;
			$scope.metric.inputDisplayType = metric.inputDisplayType;
			$scope.metric.name = metric.name;
			$scope.metric.isCategorized = !!metric.isCategorized;
			$scope.metric.metricLevelType = metric.metricLevelType;
			$scope.metric.crossSiteName = metric.crossSiteName;
			$scope.metric.resolutionType = metric.resolutionType;
			$scope.metric.samePeriodAggregation = metric.samePeriodAggregation;
			$scope.metric.valueStreamAggregation = metric.valueStreamAggregation;
			$scope.metric.valueType = metric.valueType;
			$scope.metric.valueFunction = metric.valueFunction;
			$scope.metric.targetValueType = metric.targetValueType;
			$scope.metric.targetValueFunction = metric.targetValueFunction;
			$scope.selectedValueStreamNdxs = (metric.resolutionType === 'Plant') ? '' : metric.valueStreamNdxs;
			updateSelectedValueStreams();
			$scope.pageLoaded = true;
		}

		function initFormWithDefaults() {
			$scope.metric.active = true;
			$scope.metric.chartType = 'MSLine';
			$scope.metric.controlTowerAggregationType = 'Last';
			$scope.metric.crossSiteAggregation = 'Average';
			$scope.metric.cumulative = false;
			$scope.metric.dataEntryType = 'Manual';
			$scope.metric.displayResolutionType = 'Weekly';
			$scope.metric.displayType = 'float';
			$scope.metric.goalType = 'Above';
			$scope.metric.targetPeriodType = 'Monthly';
			$scope.metric.currencyInput = 'Neither';
			$scope.metric.inputDisplayType = '';
			$scope.metric.isCategorized = false;
			$scope.metric.resolutionType = 'Plant';
			$scope.metric.samePeriodAggregation = 'Average';
			$scope.metric.valueStreamAggregation = 'Average';
			$scope.metric.valueType = 'value';
			$scope.metric.targetValueType = 'value';
			$scope.pageLoaded = true;
		}

		function clearErrorMessage() {
			$scope.errorMessage = '';
		}

		function cancel() {
			$state.go('app.setup.view-metrics');
		}

		$scope.$watch(validForm, function (formIsValid) {
			$scope.formIsValid = formIsValid;
		});

		// categorized and uncategorized metrics have different chart types
		$scope.$watch('metric.isCategorized', function () {
			updateChartTypes();
		});

		// Manual entry metrics cannot be categorized
		$scope.$watch('metric.dataEntryType', function () {
			if ($scope.metric.dataEntryType === 'Manual') {
				$scope.metric.isCategorized = false;
			}
		});
		
		$scope.$watch('metric.displayResolutionType', function (newValue, oldValue) {
			$scope.targetPeriodTypes = [{
				name: 'Monthly',
				value: 'Monthly'
			}];
			if ($scope.metric.displayResolutionType === 'Monthly') {
				if ($scope.metric.originalTargetPeriodType === undefined) {
					// no confirm dialog when creating new metric
					$scope.metric.targetPeriodType = 'Monthly';
				} else {
					changeTargetPeriodType('Monthly', oldValue);
				}
			} else {
				$scope.targetPeriodTypes.push({
					name: 'Weekly',
					value: 'Weekly'
				});
			}
		});
		
		$scope.$watch('metric.targetPeriodType', function (newValue, oldValue) {
			if (oldValue != undefined && $scope.metric.originalTargetPeriodType != undefined) {
				changeTargetPeriodType(newValue);
			}
		});

		function updateChartTypes() {
			$scope.chartTypes = [];
			var currentTypeIsValid = false;
			for (var i = 0; i < $scope.allChartTypes.length; i++) {
				if ($scope.allChartTypes[i].categorized === $scope.metric.isCategorized) {
					$scope.chartTypes.push($scope.allChartTypes[i]);
					if ($scope.metric.chartType === $scope.allChartTypes[i].value) {
						currentTypeIsValid = true;
					}
				}
			}
			// if current choice is invalid default to first option if any
			if (!currentTypeIsValid && $scope.chartTypes.length) {
				$scope.metric.chartType = $scope.chartTypes[0].value;
			}
		}

		jQuery('input#metricName').on('blur', function () {
			var metricName = jQuery(this).val();
			if ($scope.metric.description === undefined &&
				$scope.metric.crossSiteName === undefined) {
				$scope.metric.description = metricName;
				$scope.metric.crossSiteName = metricName;
			}
		});

		function validForm() {
			return ($scope.metric &&
				$scope.metric.active !== undefined &&
				$scope.metric.assignedUser !== undefined &&
				$scope.metric.category !== undefined &&
				$scope.metric.chartType !== undefined &&
				$scope.metric.controlTowerAggregationType !== undefined &&
				$scope.metric.crossSiteName !== undefined && $scope.metric.crossSiteName.length < 255 &&
				$scope.metric.cumulative !== undefined &&
				$scope.metric.dataEntryType !== undefined &&
				($scope.metric.dataEntryType === 'Automatic' || $scope.metric.inputDisplayType !== undefined) &&
				$scope.metric.displayResolutionType !== undefined &&
				$scope.metric.displayType !== undefined &&
				$scope.metric.goalType !== undefined &&
				$scope.metric.targetPeriodType !== undefined &&
				$scope.metric.currencyInput !== undefined &&
				$scope.metric.isCategorized !== undefined &&
				$scope.metric.metricLevelType !== undefined &&
				$scope.metric.name !== undefined && $scope.metric.name.length < 255 &&
				$scope.metric.resolutionType !== undefined &&
				$scope.metric.samePeriodAggregation !== undefined &&
				$scope.configureMetric.$valid &&
				($scope.metric.resolutionType === 'Plant' ||
					$scope.metric.valueStreamAggregation !== undefined &&
					$scope.selected.valueStreams !== undefined &&
					$scope.selected.valueStreams.length > 0) &&
				($scope.metric.valueType !== 'percent' ||
					$scope.metric.controlTowerAggregationType !== 'Sum' &&
					$scope.metric.crossSiteAggregation !== 'Sum' &&
					$scope.metric.samePeriodAggregation !== 'Sum' &&
					($scope.metric.resolutionType === 'Plant' ||
						$scope.metric.valueStreamAggregation !== 'Sum')) &&
				$scope.metric.valueType !== undefined &&
				$scope.metric.targetValueType !== undefined);
		}

		function submit() {
			var valueStreamNdxs = [];
			$scope.selected.valueStreams.forEach(function (vStream) {
				valueStreamNdxs.push(vStream.ndx);
			});

			var metric = {
				active: $scope.metric.active,
				assignedUserNdx: $scope.metric.assignedUser,
				categoryType: $scope.metric.category,
				chartType: $scope.metric.chartType,
				crossSiteName: $scope.metric.crossSiteName,
				crossSiteAggregation: $scope.metric.crossSiteAggregation,
				cumulative: $scope.metric.cumulative,
				dataAggregationForMonthlyRollup: $scope.metric.controlTowerAggregationType,
				description: $scope.metric.description ? $scope.metric.description : $scope.metric.name,
				displayResolutionType: $scope.metric.displayResolutionType,
				displayType: $scope.metric.displayType,
				goalType: $scope.metric.goalType,
				targetPeriodType: $scope.metric.targetPeriodType,
				currencyInput: $scope.metric.currencyInput,
				inputDisplayType: (!!!$scope.metric.inputDisplayType ? '' : $scope.metric.inputDisplayType),
				isCategorized: $scope.metric.isCategorized,
				metricLevelType: $scope.metric.metricLevelType,
				metricName: $scope.metric.name,
				metricType: $scope.metric.dataEntryType,
				resolutionType: $scope.metric.resolutionType,
				samePeriodAggregation: $scope.metric.samePeriodAggregation,
				valueFunction: $scope.metric.valueFunction,
				valueStreamAggregation: $scope.metric.valueStreamAggregation,
				valueStreamNdxs: valueStreamNdxs,
				valueType: $scope.metric.valueType,
				targetValueType: $scope.metric.valueType !== 'percent' ? 'value' : $scope.metric.targetValueType
			};
			if (newMetric) {
				configureMetricService.addMetric(metric, adminConfig.factory.id)
					.then(handleResponse);
			} else {
				configureMetricService.updateMetric(metric, $scope.metricNdx, $scope.dateModified, adminConfig.factory.id)
					.then(handleResponse);
			}

			function handleResponse(response) {
				if (response === null) {
					var message = 'Metric updated successfully';
					if (newMetric) {
						message = 'Metric added successfully';
					}
					$rootScope.$emit('toast', {
						'message': message,
						'success': true
					});
					$state.go('app.setup.view-metrics');
				} else {
					$scope.errorMessage = response.data.error;
					$timeout(function () {
						$scope.errorMessage = '';
					}, 5000);
				}
			}
		}

		function deleteMetric() {
			var confirmScope = $scope.$new();
			confirmScope.additionalText = 'delete this metric';
			confirmScope.buttonText = 'Delete';
			confirmScope.addCheckbox = true;
			confirmScope.checkboxMessage = 'This will delete all associated metric results and targets:  ';
			confirmScope.checkboxSelected = false;
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				configureMetricService.deleteMetric($scope.metricNdx, adminConfig.factory.id);
			};
		}

		function changeTargetPeriodType(newTargetPeriodType, previousFrequency) {
			if ($scope.isSelfTrigger) {
				// triggered by this dialog, don't loop
				$scope.isSelfTrigger = false;
			} else if (newTargetPeriodType == $scope.metric.originalTargetPeriodType) {
				// no confirm needed if switching to original type
				$scope.metric.targetPeriodType = newTargetPeriodType;
			} else {
				var confirmScope = $scope.$new();
				confirmScope.additionalText = 'change goal period type';
				confirmScope.buttonText = 'Change';
				confirmScope.addCheckbox = true;
				confirmScope.checkboxMessage = 'This will delete all associated metric targets:  ';
				confirmScope.checkboxSelected = false;
				var opts = {
					scope: confirmScope,
					templateUrl: '/application/f/core/confirm.html'
				};
	
				var instance = $uibModal.open(opts);
				confirmScope.closeDialog = function () {
					instance.close();
					confirmScope.$destroy();
					$scope.metric.targetPeriodType = $scope.metric.originalTargetPeriodType;
					if (previousFrequency != undefined) {
						$scope.metric.displayResolutionType = previousFrequency;
					}
				};
	
				confirmScope.yes = function () {
					instance.close();
					confirmScope.$destroy();
					$scope.isSelfTrigger = true;
					$scope.metric.targetPeriodType = newTargetPeriodType;
				};
			}
		}
	}
})();
